var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0167 0.715488C24.4431 0.346416 25.088 0.392892 25.457 0.819296L36 13L25.457 25.1807C25.088 25.6071 24.4431 25.6536 24.0167 25.2845C23.5903 24.9154 23.5438 24.2706 23.9129 23.8442L32.4517 13.9789C32.3594 14.0064 32.2616 14.0211 32.1603 14.0211H1.02111C0.457168 14.0211 0 13.5639 0 13C0 12.4361 0.457168 11.9789 1.02111 11.9789H32.1603C32.2616 11.9789 32.3594 11.9936 32.4517 12.0211L23.9129 2.15583C23.5438 1.72942 23.5903 1.08456 24.0167 0.715488ZM33.1708 12.8518C33.1778 12.9002 33.1815 12.9497 33.1815 13C33.1815 13.0503 33.1778 13.0998 33.1708 13.1482L33.299 13L33.1708 12.8518Z",
    fill: "currentColor"
  })));
};
export default SvgArrowRight;